/** Pure home of the 409 `code`s the time endpoints answer with; `lib/time.ts` re-exports them. */

/** A late Actual's ordinary submit answers 409 with this: the day must go through `useRequestCosign`. */
export const COSIGN_REQUIRED = 'cosign_required'

/** Submit on an Approved day without `confirm_reapproval` answers 409 with this: the page asks before giving the approval up. */
export const ALREADY_APPROVED = 'already_approved'
